module.exports = __webpack_public_path__ + "img/chevron-down.a0464ff5.svg";